import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RestoreRowActionOptions } from '../../../../CIMSTableContext/types/actions/row'
import {
  MutationType,
  CimsQuickLinkEntity,
  Refetch,
  RestoreCimsQuickLinkEntityOptions,
} from '../types'

export function useRestore<Restore extends MutationType>({
  mutation,
  permission,
  refetch,
  getLabel,
}: Refetch &
  RestoreCimsQuickLinkEntityOptions<Restore>): RestoreRowActionOptions<CimsQuickLinkEntity> {
  const [restore] = mutation({
    ...DefaultMutationHookOptions,
    onCompleted: (restore) =>
      simpleRestoreNotification(getLabel(restore).label),
  })
  return {
    permission,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    default: 'active',
  }
}
